import { render } from "./ProsesProfil.vue?vue&type=template&id=759040c4"
import script from "./ProsesProfil.vue?vue&type=script&lang=js"
export * from "./ProsesProfil.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__